import type { MockUser } from '@/types';

type UserProfileIdentity = Pick<MockUser, 'id' | 'profileUuid' | 'cognitoSub'>;

export function getUserProfileHref(user?: Partial<UserProfileIdentity> | null): string {
  if (user?.profileUuid) {
    return `/users/${user.profileUuid}`;
  }

  if (user?.cognitoSub) {
    return `/users/${user.cognitoSub}`;
  }

  if (typeof user?.id === 'number') {
    return `/users/${user.id}`;
  }

  return '/users';
}

export function findUserByProfileIdentifier(users: MockUser[], identifier: string): MockUser | undefined {
  const normalizedIdentifier = identifier.trim();

  if (!normalizedIdentifier) {
    return undefined;
  }

  return users.find((user) => user.profileUuid === normalizedIdentifier)
    ?? users.find((user) => user.cognitoSub === normalizedIdentifier)
    ?? (/^\d+$/.test(normalizedIdentifier)
      ? users.find((user) => String(user.id) === normalizedIdentifier)
      : undefined);
}
